import React, { useEffect, useState } from 'react';
import { Download, X, Share } from 'lucide-react';

const DISMISSED = 'oc-install-dismissed';
const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
const installed = () => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;

/** Invites phone visitors to keep Officium Connect on their home screen. */
export const InstallPrompt = ({ bottomClass = 'bottom-3' }) => {
  const [event, setEvent] = useState(null);
  const [showIosHint, setShowIosHint] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(DISMISSED) || installed()) return undefined;
    const capture = incoming => {
      incoming.preventDefault();
      setEvent(incoming);
    };
    window.addEventListener('beforeinstallprompt', capture);
    const iosTimer = isIos() ? setTimeout(() => setShowIosHint(true), 2500) : null;
    return () => {
      window.removeEventListener('beforeinstallprompt', capture);
      if (iosTimer) clearTimeout(iosTimer);
    };
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISSED, '1');
    setEvent(null);
    setShowIosHint(false);
  };

  const install = async () => {
    if (!event) return;
    event.prompt();
    await event.userChoice;
    dismiss();
  };

  if (!event && !showIosHint) return null;

  return (
    <div data-testid="install-prompt"
      className={`fixed inset-x-3 ${bottomClass} z-[60] flex items-center gap-3 rounded-2xl border border-slate-200 bg-white p-3 shadow-lg md:hidden`}
      style={{ marginBottom: 'env(safe-area-inset-bottom)' }}>
      <img src="/logo192.png" alt="" className="h-10 w-10 rounded-xl" />
      <div className="min-w-0 flex-1">
        <p className="truncate text-[13px] font-semibold text-slate-900">Keep Officium Connect handy</p>
        <p className="text-[11px] text-slate-500">
          {event ? 'Add it to your home screen for one-tap access'
            : <span className="inline-flex items-center gap-1">Tap <Share className="h-3 w-3" /> then “Add to Home Screen”</span>}
        </p>
      </div>
      {event && (
        <button type="button" onClick={install} data-testid="install-prompt-add"
          className="inline-flex shrink-0 items-center gap-1 rounded-full bg-[#0F4C81] px-3 py-2 text-[12px] font-semibold text-white">
          <Download className="h-3.5 w-3.5" />Add
        </button>
      )}
      <button type="button" onClick={dismiss} aria-label="Dismiss" data-testid="install-prompt-dismiss"
        className="shrink-0 rounded-full p-2 text-slate-400">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
